import { log } from './logger';
import Api from '../store/Api';

export const seniorAgeThresholdsByState: Record<string, number> = {
  MT: 55,
  NJ: 60,
  TX: 60,
};
export const defaultSeniorAgeThreshold = 65;

const isValidZipcode = (zip: string) => /^\d{5}$/.test(zip);

/**
 * Get the senior age threshold of a state
 * - Uses the provided state; falls back to the state of the provided zipcode
 * - Defaults to 65 if state cannot be resolved
 * @param state user's state
 * @param zipcode user's zip code
 */
export async function getSeniorAgeThreshold(
  state: string | undefined,
  zipcode: string | undefined
): Promise<number> {
  let resolvedState = null;

  // lookup by state first
  if (state) resolvedState = state;
  // or lookup by zipcode if no state is provided
  else if (zipcode && isValidZipcode(zipcode)) resolvedState = await Api.zipcodeToState(zipcode);

  if (resolvedState) {
    return seniorAgeThresholdsByState[resolvedState] ?? defaultSeniorAgeThreshold;
  } else {
    log('getSeniorAgeThreshold: no state or zipcode found, using default threshold');
    return defaultSeniorAgeThreshold;
  }
}
